@if (mandate(); as m) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center justify-between gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <div class="flex items-center gap-2">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
            <i class="pi pi-info-circle text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Información general</span>
        </div>
        <p-tag class="!text-xs" [severity]="statusSeverity(m.status)" [value]="statusLabel()" />
      </div>
      <div class="p-4">
        @if (statusReason()) {
          <p class="text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-md px-3 py-2 mb-3">{{ statusReason() }}</p>
        }
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-xs font-medium text-slate-500">Folio</p>
            <p class="text-sm font-semibold text-slate-900">{{ m.number || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Cliente</p>
            <p class="text-sm font-semibold text-slate-900">{{ m.customerName || '—' }}</p>
            @if (m.customerEmail) {
              <a [href]="'mailto:' + m.customerEmail" class="text-xs text-sky-600 hover:text-sky-800">{{ m.customerEmail }}</a>
            }
          </div>
          <div class="sm:col-span-2">
            <p class="text-xs font-medium text-slate-500">Propósito</p>
            <p class="text-sm text-slate-700">{{ m.purpose || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Referencia externa</p>
            <p class="text-sm text-slate-700 font-mono">{{ m.externalReference || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Vigencia</p>
            <p class="text-sm text-slate-700">
              {{ m.validFrom ? (m.validFrom | date:'dd/MM/yyyy') : 'Desde su activación' }}
              — {{ m.validUntil ? (m.validUntil | date:'dd/MM/yyyy') : 'sin fin' }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de alta</p>
            <p class="text-sm text-slate-700">{{ m.createdAt ? (m.createdAt | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Último cobro</p>
            <p class="text-sm text-slate-700">{{ m.lastChargedAt ? (m.lastChargedAt | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
          </div>
          @if (m.activatedAt) {
            <div>
              <p class="text-xs font-medium text-slate-500">Activado</p>
              <p class="text-sm text-slate-700">{{ m.activatedAt | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
          }
          @if (m.suspendedAt && m.status === 'SUSPENDED') {
            <div>
              <p class="text-xs font-medium text-slate-500">Suspendido</p>
              <p class="text-sm text-slate-700">{{ m.suspendedAt | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
          }
          @if (m.revokedAt) {
            <div>
              <p class="text-xs font-medium text-slate-500">Revocado</p>
              <p class="text-sm text-slate-700">{{ m.revokedAt | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
          }
          @if (m.status === 'PENDING_ENROLLMENT') {
            <div>
              <p class="text-xs font-medium text-slate-500">Cargo de registro</p>
              <p class="text-sm text-slate-700">
                @if (m.initialCharge; as initialCharge) {
                  Primer cobro {{ initialCharge.amount | currency:(m.currencyCode || 'MXN'):'symbol-narrow':'1.2-2' }}
                  @if (initialCharge.concept) { · {{ initialCharge.concept }} }
                } @else {
                  Validación que se cancela de inmediato
                }
              </p>
            </div>
            <div>
              <p class="text-xs font-medium text-slate-500">Liga de registro</p>
              <p class="text-sm text-slate-700">
                Vence {{ m.enrollmentExpiresAt ? (m.enrollmentExpiresAt | date:'dd/MM/yyyy HH:mm') : '—' }}
                · {{ m.enrollmentAttempts ?? 0 }} intento(s)
              </p>
            </div>
          }
          @if ((m.consecutiveDeclines ?? 0) > 0) {
            <div>
              <p class="text-xs font-medium text-slate-500">Declinaciones seguidas</p>
              <p class="text-sm text-slate-700">{{ m.consecutiveDeclines }} de {{ m.limits?.maxConsecutiveDeclines ?? 3 }}</p>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
          <i class="pi pi-credit-card text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Tarjeta</span>
      </div>
      <div class="px-4 py-3">
        @if (m.card?.lastDigits) {
          <p class="text-sm font-semibold text-slate-900">{{ m.card?.brand || 'Tarjeta' }} •••• {{ m.card?.lastDigits }}</p>
          <p class="text-xs text-slate-500 mt-0.5">
            {{ m.card?.type || '—' }} · Vence {{ m.card?.expirationMonth }}/{{ m.card?.expirationYear }}
          </p>
          @if (cardExpiresSoon()) {
            <p class="mt-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-amber-800 text-xs">
              La tarjeta vence en menos de 30 días. Reenvía la liga de gestión para que el cliente registre otra.
            </p>
          }
        } @else {
          <p class="text-sm text-slate-500">El cliente aún no registra su tarjeta.</p>
        }
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center justify-between gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <div class="flex items-center gap-2">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-100 text-amber-600">
            <i class="pi pi-sliders-h text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Límites</span>
        </div>
        @if (m.pendingLimits) {
          <p-tag class="!text-[10px]" severity="warn" value="Aumento pendiente" />
        }
      </div>
      @if (m.pendingLimits) {
        <p class="text-xs text-amber-800 bg-amber-50 border-b border-amber-200 px-4 py-2">
          El cliente debe aceptar los límites propuestos antes del {{ m.pendingLimitsExpiresAt | date:'dd/MM/yyyy HH:mm' }}.
          Mientras tanto aplican los vigentes.
        </p>
      }
      <div class="divide-y divide-slate-100">
        @for (row of limitRows; track row.key) {
          <div class="flex items-center justify-between gap-3 px-4 py-1.5">
            <span class="text-xs text-slate-600">{{ row.label }}</span>
            <span class="flex items-center gap-2 text-xs tabular-nums">
              <span class="text-slate-900 font-medium">{{ limitValue(row, m.limits) }}</span>
              @if (m.pendingLimits && limitChanged(row)) {
                <i class="pi pi-arrow-right text-[10px] text-slate-400"></i>
                <span class="font-semibold text-amber-700">{{ limitValue(row, m.pendingLimits) }}</span>
              }
            </span>
          </div>
        }
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
          <i class="pi pi-chart-bar text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Consumo</span>
        <span class="text-[11px] text-slate-500 normal-case">· Día y mes calendario, hora del centro de México</span>
      </div>
      <div class="px-4 py-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
        @for (bar of usageBars(); track bar.label) {
          <div>
            <div class="flex justify-between text-xs mb-1">
              <span class="text-slate-600">{{ bar.label }}</span>
              <span class="text-slate-900 font-medium tabular-nums">
                @if (bar.kind === 'amount') {
                  {{ bar.used | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}{{ bar.limit ? ' de ' : '' }}{{ bar.limit ? (bar.limit | currency:(m.currencyCode || 'MXN'):'symbol-narrow') : '' }}
                } @else {
                  {{ bar.used }}{{ bar.limit ? ' de ' + bar.limit : '' }}
                }
              </span>
            </div>
            @if (bar.limit) {
              <p-progressbar [value]="barPercent(bar)" [showValue]="false" styleClass="!h-1.5" />
            } @else {
              <p class="text-[11px] text-slate-400">Sin límite</p>
            }
          </div>
        } @empty {
          <p class="text-sm text-slate-500 sm:col-span-2">Sin consumo registrado.</p>
        }
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-teal-100 text-teal-600">
          <i class="pi pi-verified text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Consentimientos ({{ m.consents?.length ?? 0 }})</span>
      </div>
      @if (m.consents?.length) {
        <div class="divide-y divide-slate-100">
          @for (consent of m.consents; track consent.id) {
            <div class="flex items-start gap-2 px-4 py-2">
              <div class="min-w-0 flex-1">
                <div class="flex items-center gap-2 min-w-0">
                  <span class="text-xs font-semibold text-slate-900">{{ consentLabel(consent.type) }}</span>
                  <span class="text-[11px] text-slate-500 shrink-0">{{ consent.acceptedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>
                <div class="flex flex-wrap gap-1 mt-0.5">
                  <span class="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600"
                    [pTooltip]="consent.termsTextSha256" tooltipPosition="top">Términos {{ consent.termsVersion || '—' }}</span>
                  @if (consent.ipAddress) {
                    <span class="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">IP {{ consent.ipAddress }}</span>
                  }
                  @if (consent.cardLastDigits) {
                    <span class="text-[10px] px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700">•••• {{ consent.cardLastDigits }}</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin consentimientos registrados todavía.</p>
      }
    </div>

    @if (canSearchTransactions) {
      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center justify-between gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
          <div class="flex items-center gap-2">
            <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
              <i class="pi pi-receipt text-sm"></i>
            </span>
            <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Transacciones recientes</span>
          </div>
          @if (transactionsTotal() > transactions().length) {
            <a [routerLink]="['/mit-mandates', m.id]" class="inline-flex items-center gap-1 text-xs font-medium text-sky-700 hover:text-sky-900">
              Ver las {{ transactionsTotal() }} <i class="pi pi-arrow-right text-[10px]"></i>
            </a>
          }
        </div>
        @if (transactionsLoading()) {
          <div class="flex flex-col items-center justify-center py-8 gap-3">
            <i class="pi pi-spin pi-spinner text-2xl text-sky-500"></i>
            <p class="text-sm text-slate-500">Cargando transacciones...</p>
          </div>
        } @else if (transactions().length === 0) {
          <p class="text-sm text-slate-500 px-4 py-3">Este mandato aún no tiene transacciones.</p>
        } @else {
          <div class="divide-y divide-slate-100">
            @for (tx of transactions(); track tx.id) {
              <div class="flex items-center gap-2 px-4 py-2">
                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-2 min-w-0">
                    <span class="text-xs font-semibold text-slate-900 truncate">{{ tx.concept || txTypeLabel(tx.type) }}</span>
                    <span class="text-[11px] text-slate-500 shrink-0">{{ tx.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <div class="flex flex-wrap items-center gap-1 mt-0.5">
                    <p-tag class="!text-[10px]" [severity]="txSeverity(tx.status)" [value]="txStatusLabel(tx.status)" />
                    <span class="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{{ txTypeLabel(tx.type) }}</span>
                    @if (txDetail(tx)) {
                      <span class="text-[11px] text-slate-500 truncate">{{ txDetail(tx) }}</span>
                    }
                  </div>
                </div>
                <span class="text-xs font-bold text-slate-900 shrink-0 tabular-nums">
                  {{ tx.amount | currency:(tx.currencyCode || m.currencyCode || 'MXN'):'symbol-narrow':'1.2-2' }}
                </span>
                @if (canReadTransactions && tx.id != null) {
                  <a
                    [routerLink]="['/mit-transactions', tx.id]"
                    class="shrink-0 flex h-7 w-7 items-center justify-center rounded-md text-sky-600 hover:bg-sky-50 hover:text-sky-800"
                    title="Ver transacción">
                    <i class="pi pi-eye text-xs"></i>
                  </a>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
